var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "automation-block-editor webhook" }, [
    _c(
      "div",
      { staticClass: "editor-row customize-editor-minimize" },
      [
        _c("div", { staticClass: "editor-row-title" }, [
          _vm._v("URL (required)"),
        ]),
        _vm._v(" "),
        _c("TiptapEditor", {
          attrs: {
            placeholder: "URL",
            "show-attributes": true,
            "max-character-count": 500,
            "automation-mode": "",
          },
          model: {
            value: _vm.clone.url,
            callback: function ($$v) {
              _vm.$set(_vm.clone, "url", $$v)
            },
            expression: "clone.url",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "editor-row customize-editor-minimize" },
      [
        _c("div", { staticClass: "editor-row-title" }, [_vm._v("Method:")]),
        _vm._v(" "),
        _c("CustomPicker", {
          attrs: {
            items: _vm.methods,
            idKey: "id",
            labelKey: "label",
            title: "Select Method",
          },
          model: {
            value: _vm.clone.method,
            callback: function ($$v) {
              _vm.$set(_vm.clone, "method", $$v)
            },
            expression: "clone.method",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        key: _vm.clone.payloadType,
        staticClass: "editor-row customize-editor-minimize",
      },
      [
        _c("div", { staticClass: "editor-row-title" }, [
          _vm._v("Payload Type"),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "btnGroup" },
          _vm._l(["json", "form", "xml", "raw"], function (type) {
            return _c(
              "SupsisButton",
              {
                key: type,
                attrs: {
                  classNames:
                    _vm.clone.payloadType === type
                      ? "btnGroupItem selected"
                      : "btnGroupItem ",
                  primary: _vm.clone.payloadType === type,
                  ghost: _vm.clone.payloadType !== type,
                  small: "",
                },
                on: {
                  click: function () {
                    return _vm.changePayloadType(type)
                  },
                },
              },
              [_vm._v("\n                " + _vm._s(type) + "\n            ")]
            )
          }),
          1
        ),
        _vm._v(" "),
        _c("TiptapEditor", {
          attrs: {
            placeholder: "Payload Type",
            "show-attributes": true,
            "automation-mode": "",
          },
          model: {
            value: _vm.clone.payloadType,
            callback: function ($$v) {
              _vm.$set(_vm.clone, "payloadType", $$v)
            },
            expression: "clone.payloadType",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "editor-row customize-editor-minimize data-items" },
      [
        _c("div", { staticClass: "editor-row-title" }, [_vm._v("Headers")]),
        _vm._v(" "),
        _vm._l(_vm.clone.headers || [], function (item, index) {
          return _c("DataItem", {
            key: index,
            on: {
              delete: function () {
                return _vm.deleteHeaderItem(index)
              },
            },
            model: {
              value: _vm.clone.headers[index],
              callback: function ($$v) {
                _vm.$set(_vm.clone.headers, index, $$v)
              },
              expression: "clone.headers[index]",
            },
          })
        }),
        _vm._v(" "),
        _c(
          "SupsisButton",
          { attrs: { small: "", ghost: "" }, on: { click: _vm.addHeaderItem } },
          [_vm._v(" Add Header")]
        ),
      ],
      2
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "editor-row customize-editor-minimize data-items" },
      [
        _c("div", { staticClass: "editor-row-title" }, [_vm._v("Data")]),
        _vm._v(" "),
        _vm._l(_vm.clone.data || [], function (item, index) {
          return _c("DataItem", {
            key: index,
            on: {
              delete: function () {
                return _vm.deleteDataItem(index)
              },
            },
            model: {
              value: _vm.clone.data[index],
              callback: function ($$v) {
                _vm.$set(_vm.clone.data, index, $$v)
              },
              expression: "clone.data[index]",
            },
          })
        }),
        _vm._v(" "),
        _c(
          "SupsisButton",
          { attrs: { small: "", ghost: "" }, on: { click: _vm.addDataItem } },
          [_vm._v(" Add Data")]
        ),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }